module.exports = __webpack_public_path__ + "media/svg-new/login 1-e7dd203c.jpg";